import { Controller } from '@hotwired/stimulus'
import { formatUsPhone } from '../embed/phone'

export default class extends Controller {
  // Phone keypad for fields with no picker; the controller sits on a form, a wrapper or the input.
  connect() {
    const selector = '[data-action~="input->mask#phone"]'
    const inputs = Array.from(this.element.querySelectorAll(selector))
    if (this.element.matches(selector)) inputs.push(this.element)
    inputs.forEach((input) => input.setAttribute('inputmode', 'tel'))
  }

  // Formats US numbers. A picker set to another country, or a typed or pasted non-US "+<dial code>",
  // keeps digits only, with the leading + so the picker can switch the flag. The value is written on
  // every keystroke, even unchanged: Firefox can leave a field it autofilled flagged as empty (placeholder
  // drawn under the digits, `required` failing) until a script writes it. An unchanged write keeps the caret.
  phone(event) {
    const input = event.target
    const flag = input.parentNode.querySelector('.iti__selected-flag')
    const us = flag == null || flag.title == 'United States: +1'
    const value = input.value.trim()
    input.value = us && !/^\+(?!1)/.test(value) ? formatUsPhone(value) : value.replace(/(?!^\+)\D/g, '')
  }
}
